//GeneratorFlag:[NoChange]
import AccessAgent from './access-agent';
import AccessKeys from './access-keys';

export default {AccessAgent, AccessKeys}
export{AccessAgent, AccessKeys}